var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-edit m-1",attrs:{"disabled":_vm.disabled,"small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fas fa-pen mr-2 text-twenty"}),_vm._v(" EDITAR ")])}
var staticRenderFns = []

export { render, staticRenderFns }